import { Reveal, Eyebrow } from "@/lib/motion";
import { STEPS } from "@/data";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-brand-ink text-brand-cream my-16 md:my-24 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-9">
            <Eyebrow className="!text-brand-sage">How it works</Eyebrow>
            <h2 className="mt-5 font-display font-normal text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              From idea to a live agent in about two weeks.
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-teal/40 rounded-3xl overflow-hidden">
          {STEPS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.1}>
              <div className="bg-brand-ink p-8 md:p-10 h-full" data-testid={`step-${s.no}`}>
                <div className="font-display text-6xl md:text-7xl text-brand-sage/70 mb-6">{s.no}</div>
                <h3 className="font-display text-2xl md:text-3xl mb-4">{s.title}</h3>
                <p className="text-brand-cream/70 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
